/**
 * Turning the server's category refusals into something a person can
 * act on (RESP2d).
 *
 * Two codes, two different next steps, one shared module so the task
 * form and the report form cannot drift into wording them differently.
 * The raw API sentence is never shown for these: it is written for a
 * developer reading a log, and it does not tell the person what to do.
 */
/**
 * RESP2d: a category that was retired while this form was open.
 *
 * The backend refuses it with a stable code, and the useful response is
 * not a toast — it is to refetch the catalog so the picker stops
 * offering the dead option, and to say plainly what happened. The form
 * stays open and every other field keeps what the person typed;
 * throwing that away to deliver bad news would be its own small insult.
 *
 * Returns the sentence to show, or ``null`` when the failure is not a
 * category problem and the caller's own message should be used.
 */
/** The code a list endpoint returns for an unusable area filter. */
export const ERR_CATEGORY_FILTER_INVALID = "activity_category_filter_invalid";

/**
 * RESP2e: is this failure an unusable AREA FILTER?
 *
 * Distinguished from a network error because the two need different
 * offers: "try again" fixes a flaky connection and will never fix a
 * link naming an area that no longer exists. Only the second deserves
 * a "clear the filter" button, and offering it for both would teach
 * people to discard their filters whenever anything goes wrong.
 */
export function isActivityCategoryFilterError(err) {
  return err?.code === ERR_CATEGORY_FILTER_INVALID;
}

/** The sentence shown when a stored or shared filter cannot be used. */
export const CATEGORY_FILTER_INVALID_MESSAGE =
  "Der Bereichsfilter enthält einen Bereich, den es nicht mehr gibt. " +
  "Bitte setzen Sie den Bereichsfilter zurück.";

export function activityCategoryErrorMessage(err) {
  switch (err?.code) {
    case ERR_CATEGORY_FILTER_INVALID:
      return CATEGORY_FILTER_INVALID_MESSAGE;
    case "activity_category_inactive":
      return (
        "Dieser Bereich wurde inzwischen deaktiviert. Bitte wählen Sie " +
        "einen anderen Bereich."
      );
    case "activity_category_not_found":
      return (
        "Dieser Bereich ist nicht mehr verfügbar. Bitte wählen Sie einen " +
        "anderen Bereich."
      );
    default:
      return null;
  }
}
